<template>
  <transaction-list
    :transactionService = transactionService
    :productService = productService
    :locationService = locationService
    :showCost = showCost
  ></transaction-list>
</template>
<script>
  import TransactionList from '@/components/Common/Transaction/TransactionList'
  import transactionService from '@/services/rental/transaction'
  import productService from '@/services/rental/product'
  import locationService from '@/services/rental/location'
  import {mapGetters} from 'vuex'

  export default {
    components: {
      TransactionList
    },
    data () {
      return {
        transactionService: transactionService,
        productService: productService,
        locationService: locationService
      }
    },

    computed: {
      ...mapGetters('acl', [
        'matchRoles'
      ]),

      showCost () {
        return this.matchRoles(['machine_operation'])
      }
    },

    created () {
      this.$store.commit('UPDATE_TITLE', 'Transactions')
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/Rental/Transactions/Overview.vue